import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { BottomSheet } from 'react-spring-bottom-sheet';
import InternalLink from '../../input/InternalLink';
import CloseIcon from '../../content/CloseIcon';
import TermsContent from '../../content/TermsContent';
import ClosableModal from '../ClosableModal';

type TermsAndConditionsHeaderProps = {
  onClose: () => void;
};

const TermsAndConditionsHeader: React.FC<TermsAndConditionsHeaderProps> = ({
  onClose,
}: TermsAndConditionsHeaderProps) => (
  <div className="flex flex-row justify-between items-start">
    <span className="m-2 text-black-600 text-2xl">Terms & Conditions</span>
    <span
      data-testid="modal-close-button"
      className="pr-4 pt-6 modal-close-button text-lg"
      onClick={onClose}
      role="button"
      tabIndex={0}
      onKeyDown={onClose}
    >
      <CloseIcon />
    </span>
  </div>
);

const TermsAndConditions: React.FC = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleIsModalOpen = (): void => {
    setIsModalOpen(!isModalOpen);
  };
  return (
    <div className="text-center text-xs">
      By clicking Pay, you&apos;re agreeing to the{' '}
      {isMobile ? (
        <>
          <InternalLink onClick={toggleIsModalOpen}>
            terms and conditions
          </InternalLink>
          .
          <BottomSheet
            open={isModalOpen}
            onDismiss={toggleIsModalOpen}
            defaultSnap={({ snapPoints, lastSnap }): number =>
              lastSnap ?? Math.min(...snapPoints)
            }
            snapPoints={({ maxHeight }): number => maxHeight * 0.9}
            blocking
            header={<TermsAndConditionsHeader onClose={toggleIsModalOpen} />}
          >
            <div className="grid grid-flow-row place-items-start mx-2 overflow-y-scroll">
              <TermsContent />
            </div>
          </BottomSheet>
        </>
      ) : (
        <>
          <InternalLink onClick={toggleIsModalOpen}>
            terms and conditions
          </InternalLink>
          .
          <ClosableModal
            label="Terms & Conditions"
            isOpen={isModalOpen}
            onRequestClose={(): void => setIsModalOpen(false)}
          >
            <TermsContent />
          </ClosableModal>
        </>
      )}
    </div>
  );
};

export default TermsAndConditions;
